import React from "react";
import styled from "styled-components";
import onWebviewClose from "./Button";
import AlertCircle from "./AlertCircle";

const Container = styled.div`
  background-color: var(--bg-color);
  width: 100%;
  min-height: 100vh;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--text-color);
`;

const WarningIcon = styled.div`
  position: absolute;
  width: 80px;
  height: 76px;
  left: 50%;
  top: 50%;
  margin-left: -40px;
  margin-top: -38px;
`;

const ErrorMsg = styled.div`
  position: absolute;
  top: 50%;
  width: 100%;
  text-align: center;
  margin-top: 43px;
`;

const CloseBtn = styled.button`
  font-size: 1.5rem;
  background-color: transparent;
  border: 0;
  position: absolute;
  top: 0;
  right: 0;
  outline: 0;
  padding: 0px;
  color: var(--text-color);
`;

function NotFoundError() {
  return (
    <>
      <Container>
        <button
          id="backkeyTrigger"
          style={{ display: "none" }}
          onClick={onWebviewClose}
        ></button>
        <CloseBtn onClick={onWebviewClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
              minHeight: "2.75rem",
              marginTop: "4px",
              marginRight: "1.1875rem",
            }}
            width="28"
            height="28"
            viewBox="0 0 28 28"
          >
            <g fill="none" fillRule="evenodd">
              <g fillRule="nonzero">
                <g>
                  <path
                    d="M0 0H28V28H0z"
                    transform="translate(-596 -8) translate(596 8)"
                  />
                  <path
                    fill="currentColor"
                    d="M21.467 6.535c.466.467.466 1.05.116 1.517l-.116.117-5.717 5.833 5.833 5.717c.467.466.467 1.166 0 1.633-.466.467-1.05.467-1.516.117l-.234-.117L14 15.635 8.167 21.47c-.467.466-1.167.466-1.634 0-.466-.467-.466-1.05-.116-1.517l.116-.117 5.834-5.833-5.834-5.717c-.466-.466-.466-1.166 0-1.633.467-.467 1.05-.467 1.517-.117l.117.117L14 12.37l5.717-5.717c.583-.583 1.283-.583 1.75-.117z"
                    transform="translate(-596 -8) translate(596 8)"
                  />
                </g>
              </g>
            </g>
          </svg>
        </CloseBtn>
        <WarningIcon>
          <AlertCircle width={80} height={76} color="var(--text-color)" />
        </WarningIcon>
        <ErrorMsg>
          {/* {this.state.error.message} */}
          404 Not Found
        </ErrorMsg>
      </Container>
    </>
  );
}

export default NotFoundError;
